export const findQuickWinsCommandText = "zoXAGd";
export const findQuickWinsDisplayText = "SKl$uc";
export const getOrientedCommandText = "qf$hLb";
export const getOrientedDisplayText = "JBzSz";
export const suggestNextStepsCommandText = "cjKoSe";
export const suggestNextStepsDisplayText = "vF_YGd";
export const summarizeCommandText = "xW45Vb";
export const summarizeDisplayText = "QgtEK";
export const summarizeAndReplyCommandText = "sBGc4b";
export const summarizeAndReplyDisplayText = "LX6MS";
export const triageMyInboxCommandText = "IOjPz";
export const triageMyInboxDisplayText = "vUON9d";
export const showKeyTakeawaysCommandText = "aQ18Rc";
export const showKeyTakeawaysDisplayText = "taqHGb";
export const showRelatedResourcesCommandText = "xpIwG";
export const showRelatedResourcesDisplayText = "kvbvee";
export const needsUrgentRepliesCommandText = "qDEoLd";
export const needsUrgentRepliesDisplayText = "JZ4Yzc";
export const showTopActionItemsCommandText = "Yo06Se";
export const showTopActionItemsDisplayText = "pLoFHd";
export const latestOnTopicCommandText = "h8Grjc";
export const latestOnTopicDisplayText = "As719";
export const whatToGetToFirstCommandText = "oIO4J";
export const whatToGetToFirstDisplayText = "bOh3he";
export const showMyTopThreeEmailsCommandText = "NC6Vod";
export const showMyTopThreeEmailsDisplayText = "eZuudc";
export const inboxBriefingDisplayText = "zSf0ze";
export default {findQuickWinsCommandText,findQuickWinsDisplayText,getOrientedCommandText,getOrientedDisplayText,suggestNextStepsCommandText,suggestNextStepsDisplayText,summarizeCommandText,summarizeDisplayText,summarizeAndReplyCommandText,summarizeAndReplyDisplayText,triageMyInboxCommandText,triageMyInboxDisplayText,showKeyTakeawaysCommandText,showKeyTakeawaysDisplayText,showRelatedResourcesCommandText,showRelatedResourcesDisplayText,needsUrgentRepliesCommandText,needsUrgentRepliesDisplayText,showTopActionItemsCommandText,showTopActionItemsDisplayText,latestOnTopicCommandText,latestOnTopicDisplayText,whatToGetToFirstCommandText,whatToGetToFirstDisplayText,showMyTopThreeEmailsCommandText,showMyTopThreeEmailsDisplayText,inboxBriefingDisplayText};